module.exports = __webpack_public_path__ + "assets/img/nooc.77b0dd4a.png";